import { Configuration, LogLevel } from "@azure/msal-browser";
import TelemetryService from "services/telemetryService";

export const ConfigMsal: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO.
    // If you wish to store cache items in cookies as well as browser cache, set this to "true".
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            TelemetryService.AppInsights?.trackException({
              exception: new Error(message),
              properties: { source: "msal" },
            });
            return;
        }
      },
      piiLoggingEnabled: false,
    },
  },
};
